<template>
    <div>
        <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12 md12>
                    <v-text-field
                        v-model="RoleName"
                        v-validate="'required'"
                        label="Name *"

                        required
                        :error-messages="errors.collect('Name')"
                        data-vv-name="Name"
                    />
                </v-flex>

                <v-flex xs12>
                    <v-text-field
                        v-model="RoleDescription"
                        v-validate="'required'"
                        label="Description *"

                        required
                        :error-messages="errors.collect('Description')"
                        data-vv-name="Description"
                    />
                </v-flex>

                <v-flex xs12>
                    <div class="role-tree-container">
                        <RoleTreeNode ref="permission-tree" :options="finalList" />
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-btn color="primary" class="save-btn" @click="saveRole()">Save</v-btn>
        </v-container>
    </div>
</template>

<script>
import RoleTreeNode from "./RoleTreeNode";
import SaveConfirmation from "@/smallComponents/Dialog/DialogContent/SaveConfirmation";
export default {
    name: "AddRole",
    components: { RoleTreeNode },

    data () {
        return {
    	permissions: [],

    	RoleName: [],
    	RoleDescription: [],
    	RolePermission: [],

            selectedPermissions: [],
            finalList: [],

            alert: false,
        };
    },
    mounted() {
  	this.getPermission();
    },
    methods: {
  	getPermission() {
  		var self = this;
  		axios({
  		  method: "GET",
  		  url: "Permission/GetAllTrialPermissions",
  		})
  		.then(function (response) {
                    self.permissions = response.data.result.items;
  		  self.permissions.map((permission,index) => {
                        permission.id = permission.name;
                        permission.label = permission.displayName;
                    });

                    var roots = []; // things without parent

                    // make them accessible by guid on this map
                    var all = {};

                    self.permissions.forEach(function(item) {
                        all[item.name] = item;
                    });

                    // connect childrens to its parent, and split roots apart
                    Object.keys(all).forEach(function (name) {
                        var item = all[name];
                        if (item.parentName === null) {
                            roots.push(item);
                        } else if (item.parentName in all) {
                            var p = all[item.parentName];
                            if (!("children" in p)) {
                                p.children = [];
                            }
                            p.children.push(item);
                        }
                    });

                    // done!
                    self.finalList = (roots);
  		});
  	},
  	saveRole() {
            var self = this;
            this.selectedPermissions = this.$refs["permission-tree"].getCheckedKeys();
            this.$validator.validateAll().then(result => {
                if (result) {
                    DialogBus.$emit("open", {
                        component: SaveConfirmation,
                        title: "Are you sure",
                        onSuccess: function onSuccess() {
                            self.confirmCreate();
                        }
                    });
                }
            });
        },
        confirmCreate() {
            var self = this;
            axios({
                method: "POST",
                url: "TrialRole/Create",
                data: {
                    "name": this.RoleName,
                    "displayName": this.RoleName,
                    "description": this.RoleDescription,
                    "isStatic": false,
                    "grantedPermissions": this.selectedPermissions
                }
            })
                .then(function (response) {
                    EventBus.$emit("snackBar", {
                        text: "Role Created Succesfully",
                        snackbarColor: "green darken-2"
                    });

                    self.RoleName = "";
                    self.RoleDescription = "";
                    self.selectedPermissions = [];
                    self.errors.items = [];

                    self.$refs["permission-tree"].clearNodes();

                    self.reloadTable("#RoleTable");
                });
            self.$emit("update:comfirmFn", false);
        },
        getSelectValue(selectedValue) {
            this.$nextTick(function() {
                var CreateExp_P = "Permissions.Research.Experiments.Create";
                var EditExp_P = "Permissions.Research.Experiments.Edit";
                var Palm_P = ["Permissions.Research.Palms","Permissions.Research.Palms.Create","Permissions.Research.Palms.Edit","Permissions.Research.Palms.Delete"];
                var Progeny_P = ["Permissions.Research.Progenies","Permissions.Research.Progenies.Create","Permissions.Research.Progenies.Edit","Permissions.Research.Progenies.Delete"];

                var mySet = new Set();

                // Force them to select Palm and Progeny when Create Exp / Edit Exp Permissions is choosed. 
                if ((this.selectedPermissions.includes(CreateExp_P) || this.selectedPermissions.includes(EditExp_P)) && (!this.selectedPermissions.includes(Palm_P) || !this.selectedPermissions.includes(Progeny_P)) ) {

                    this.selectedPermissions.forEach(item => {
                        mySet.add(item);
                    });

                    Palm_P.forEach(item => {
                        mySet.add(item);
                    });

                    Progeny_P.forEach(item => {
                        mySet.add(item);
                    });

                    var myArray = [...mySet];
                    this.selectedPermissions = myArray.slice();
                    this.alert = true;
                }
            });
        }
    }
};
</script>

<style lang="css" scoped>
.save-btn{
	margin: 0;
}
.treeSelect::placeholder{
  font-size: 17px;
  color: red;
}
.role-tree-container{
  height: 300px;
  overflow: auto;
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid var(--table-odd-grey)
}
</style>




// WEBPACK FOOTER //
// src/components/UMS/TrialManagement/AddRole.vue